/**
 * Converts a File to a data URI (`data:<mime>;base64,<payload>`) for the `logo` field of
 * POST /v1/admin/partners.
 *
 * A data URI, not bare base64: the backend's `processBase64ToMetadata` does
 * `data.split(',')` and reads index 1 as the payload, so bare base64 (no comma) uploads an
 * empty file and silently produces a broken logo. This matches what the Retool app sent.
 *
 * Uses `arrayBuffer()` rather than `FileReader` so the helper is testable under admin's
 * `environment: 'node'` vitest config, where `FileReader` does not exist.
 */
export const fileToDataUrl = async (file: File): Promise<string> => {
  const buffer = await file.arrayBuffer()
  const bytes = new Uint8Array(buffer)

  let binary = ''

  for (let index = 0; index < bytes.byteLength; index += 1) {
    binary += String.fromCharCode(bytes[index])
  }

  const mimeType = file.type || 'application/octet-stream'

  return `data:${mimeType};base64,${btoa(binary)}`
}
